(function (factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "module"], factory);
  } else if (typeof exports !== "undefined" && typeof module !== "undefined") {
    factory(exports, module);
  }
})(function (exports, module) {
  "use strict";

  module.exports = function (element) {
    var namespace = arguments[1] === undefined ? "" : arguments[1];

    var data = element.__SKATE_DATA || (element.__SKATE_DATA = {});
    return namespace && (data[namespace] || (data[namespace] = {})) || data;
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/skatejs/lib/data.js
// module id = 65
// module chunks = 0